import { useState } from "react";
import { FaCheck } from "react-icons/fa6";
import style from "./Checkbox.module.css";

function Checkbox({
  title = "",
  className = "",
  ref,
  onChange,
  value,
  onBlur,
  ...props
}) {
  const [random] = useState((Math.random() + 1).toString(36).substring(7));

  return (
    <div>
      <label
        htmlFor={random}
        className={
          "d-flex align-items-center " +
          style.box +
          (className ? " " + className : "")
        }
      >
        <input
          id={random}
          type="checkbox"
          className={style.input}
          ref={ref}
          onChange={onChange}
          checked={value ?? false}
          onBlur={onBlur}
          {...props}
        />
        <div className={style.wrapper}>
          <span className={style.icon + (value ? " " + style.true : "")}>
            <FaCheck />
          </span>
        </div>

        <span className="user-select-none me-2">{title}</span>
      </label>
    </div>
  );
}

export default Checkbox;
